import React, {FC} from 'react';

import QuestionCurrency from '../../components/QuestionCurrency';

const StepMonthlyExpenses: FC = () => (
  <QuestionCurrency field="monthlyExpenses" />
);

export default StepMonthlyExpenses;
